commusoftCommon.filter('nextServiceDate', function(CS_LANGUAGE) {
    return function(dateString) {
        moment.locale(CS_LANGUAGE);
        return moment.utc(dateString).zone(moment().format('Z')).format('Do MMMM YYYY')
    };
});